// src/locales/ta/pos.js — Tamil
import { pos as posEn } from '../en/pos';

export const pos = {
  ...posEn,
  session: 'அமர்வு',
  paymentFee: 'கட்டணம்',
  feeAbsorbed: 'வணிகம்',
  feeChargedToCustomer: 'வாடிக்கையாளர்',
  totalPaymentFees: 'மொத்த கட்டண கட்டணங்கள்',
  paymentFeesCustomer: 'கட்டணங்கள் (வாடிக்கையாளர்)',
  productCostCol: 'செலவு',
  paymentFeesCol: 'கட்டணங்கள்',
  profitCol: 'லாபம்',
  totalProductCost: 'தயாரிப்பு செலவு',
  grossProfit: 'மொத்த லாபம்',
  searchOrdersPlaceholder: 'ஆர்டர் #, வாடிக்கையாளர் பெயர், தொலைபேசி தேடு...',
  filterByCustomer: 'வாடிக்கையாளர் மூலம் வடிகட்டு',

  // Dynamic order status labels
  status_completed:          'முடிந்தது',
  status_voided:             'ரத்து செய்யப்பட்டது',
  status_on_hold:            'நிறுத்தி வைக்கப்பட்டது',
  status_credit:             'கடன்',
  status_returned:           'திரும்பியது',
  status_partially_returned: 'பகுதியளவு திரும்பியது',

  // Dynamic payment status labels
  payment_paid:    'செலுத்தப்பட்டது',
  payment_partial: 'பகுதி',
  payment_unpaid:  'செலுத்தப்படாத',

  // Payment method keys
  bank_transfer: 'வங்கி இடமாற்றம்',

  // Receipt share buttons
  shareInvoice: 'இன்வாய்ஸ் பகிர்',
  sendViaWhatsApp: 'WhatsApp',
  sendViaSms: 'SMS அனுப்பு',
  sendingInvoice: 'அனுப்புகிறது…',
  smsSent: 'SMS அனுப்பப்பட்டது',
};
